export const TAB_ALL = 'all';
export const TAB_MENTIONS = 'mentions';

/** Pixels from the list bottom that count as "reached the end". */
export const NEAR_BOTTOM_PX = 8;

/** Opens the Video Intelligence panel on the Transcript tab. */
export const VIDEO_AI_TRANSCRIPT_HASH = 'videoAi|transcript';
export const VIDEO_AI_TRANSCRIPT_TYPES = [
  'asset.videoAnalyzing.complete',
  'asset.videoAnalyzing.failed',
  'asset.transcript.deleted',
  'asset.transcribing.complete',
];

export const GONE_EVENT_TYPES = [
  'inbox.deleted',
  'collection.deleted',
  'collection.archived.deleted',
  'assets.deleting.complete',
  'face.deleted',
  'system.message',
  'asset.adobe_uploaded',
  'websiteSettingsPreset.created',
  'websiteSettingsPreset.deleted',
  'websiteSettingsPreset.renamed',
];

export const COMMENT_EVENT_TYPES = [
  'asset.comment.added',
  'asset.comment.deleted',
];

export const TEAM_EVENT_TYPES = [
  'invitation.accepted',
  'invitation.pending',
  'invitation.rejected',
  'invitation.sent',
  'request.created',
];

export const BILLING_EVENT_TYPES = [
  'user.trial.expires',
  'user.trial.expires_in_five_days',
  'user.trial.expires_in_two_days',
  'user.free_keywords_run_out',
];
